import { createAppSlice } from 'creators';
import { get } from 'api/requests';

import { Toast } from '@10d/tend-ui/primitives/Toast';

import { IGetPlanApartmentsParams, PlanApartmentsResponse } from 'types';
import { UploadingApartmentsPlanInitial } from 'features/UploadingPlan/types';

const initialState: UploadingApartmentsPlanInitial = {
  uploadingPlansApartments: [] as PlanApartmentsResponse[],
  uploadingPlansApartmentsLoading: false,
  downloadApartmentsTemplateloading: false,
  requestId: undefined,
};

export const uploadingPlansApartmentsSlice = createAppSlice({
  name: 'uploadingPlansApartments',
  initialState,
  reducers: create => ({
    reset: create.reducer(() => initialState),
    // Запрос для получения шахматки
    getPlans: create.asyncThunk(
      async (params: IGetPlanApartmentsParams, thinkApi) => {
        try {
          if (params.project) {
            const response = await get<PlanApartmentsResponse[]>(
              '/api/v2/settlement/plan/',
              params,
            );
            return response.data;
          } else {
            Toast.error({ message: 'Проект не выбран' });
          }
        } catch (error) {
          return thinkApi.rejectWithValue(error);
        }
      },
      {
        pending: (state, { meta }) => {
          return { ...state, requestId: meta.requestId, uploadingPlansApartmentsLoading: true };
        },
        rejected: (state, { meta }) => {
          if (state.requestId === meta.requestId) {
            state.uploadingPlansApartmentsLoading = false;
          }
        },
        fulfilled: (state, { payload }) => {
          state.uploadingPlansApartmentsLoading = false;

          if (payload) {
            state.uploadingPlansApartments = payload;
          }
        },
      },
    ),
    // Скачивание шаблона
    getDownloadTemplate: create.asyncThunk(
      async (params: { project: number; structure: number | null }, thinkApi) => {
        try {
          const response = await get('/api/v2/settlement/plan/template/', params, {
            responseType: 'arraybuffer',
            headers: {
              'Content-Type': 'blob',
            },
          });
          return response;
        } catch (error) {
          return thinkApi.rejectWithValue(error);
        }
      },
      {
        pending: (state, { meta }) => {
          return { ...state, requestId: meta.requestId, downloadApartmentsTemplateloading: true };
        },
        rejected: (state, { meta }) => {
          if (state.requestId === meta.requestId) {
            state.downloadApartmentsTemplateloading = false;
          }
        },
        fulfilled: (state, { payload }) => {
          state.downloadApartmentsTemplateloading = false;

          if (payload) {
            const [, filename] = decodeURI(payload.headers['content-disposition']).split(
              'filename*=utf-8',
            );
            // @ts-ignore Type 'unknown' is not assignable to type 'BlobPart'
            const url = window.URL.createObjectURL(new Blob([payload.data]));
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', filename.slice(2));

            document.body.appendChild(link);
            link.click();
            link.remove();
          }
        },
      },
    ),
  }),
});

export const {
  reset: setReset,
  getPlans,
  getDownloadTemplate,
} = uploadingPlansApartmentsSlice.actions;
